import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import HttpClient from "src/http/http-client";

/**
 * 机构相关服务
 * @class
 * @version 1.0.0
 */
export default class OrgService extends ServiceBase
{

    /**
     * 实例
     * @private
     * @return OrgService
     */
     private static _instance: OrgService;

    /**
     * 实例
     * @static
     * @property
     * @returns OrgService
     */
    public static get instance(): OrgService
    {
        if(!this._instance)
        {
            this._instance = new OrgService();
        }
        
        return this._instance;
    }

    /**
     * 获取机构列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getPackageHospitals(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getPackageHospitals({ 
            data: data 
        });
        
        return response;
    }


}